/** Repair only Composer-owned orphan placeholders when their product area is unambiguous. */
export const restoreComposerPlaceholderAreas = (design: MPlaza.Design, model: MPlaza.Model) => {
    const color = model.get('colors').at(0);
    const meshSides = model.get('scenes').at(0)?.get('meshSides');
    if (!color || !meshSides) return;
    design.get('designItems').forEach((item) => {
        if (item.get('areas').length) return;
        let data: any;
        try {
            data = JSON.parse(item.get('json') || '')?.[1]?.data;
        } catch {
            return;
        }
        if (!data?.composerPlaceholderText) return;
        const candidates = color
            .get('sides')
            .filter((side) =>
                data.composerPlaceholderAreaGuid
                    ? side.get('areas').models.some((area) => area.get('guid') === data.composerPlaceholderAreaGuid)
                    : !!data.composerPlaceholderMeshID &&
                      meshSides.models.some((mesh) => mesh.get('meshID') === data.composerPlaceholderMeshID && mesh.get('sideID') === side.get('sideID'))
            );
        if (candidates.length !== 1) return; // Never guess when areas share a mesh.
        const side = candidates[0];
        const area = side.get('areas').at(0);
        if (!area) return;
        const reference = new MPlaza.DesignItemArea();
        reference.set('modelID', model.get('modelID'));
        reference.set('colorID', color.get('colorID'));
        reference.set('sideID', side.get('sideID'));
        reference.set('areaID', area.get('areaID'));
        item.get('areas').add(reference);
    });
};
